export default __webpack_public_path__ + "static/media/Version (2) - LOTR_00.36397d37.jpg";